<div class="yearly-report-overlay" *ngIf="visible" (click)="close.emit()">
  <div class="yearly-report-full-modal" (click)="$event.stopPropagation()">
    <button class="yearly-report-close-icon" type="button" [attr.aria-label]="'common.close' | t" (click)="close.emit()">&times;</button>
    <div class="yearly-report-header-row">
      <h3>{{ 'report.yearlyTitle' | t }} ({{ year }})</h3>
      <button
        *ngIf="!loading && hasAnyData"
        type="button"
        class="yearly-report-pdf-btn"
        (click)="downloadPdfReport()"
      >
        <span class="yearly-report-pdf-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M12 3a1 1 0 0 1 1 1v8.59l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 3.99a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42L11 12.6V4a1 1 0 0 1 1-1z"></path>
            <path d="M5 18a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"></path>
          </svg>
        </span>
        <span>{{ 'report.pdf' | t }}</span>
      </button>
    </div>

    <div class="yearly-report-top-grid">
      <section class="report-info-card">
        <h4>{{ 'report.flatInformation' | t }}</h4>
        <div class="report-info-inline">
          <span>{{ 'report.flat' | t }}: <strong>{{ displayValue(flatLabel) }}</strong></span>
          <span>{{ 'report.floor' | t }}: <strong>{{ displayValue(floorLabel) }}</strong></span>
          <span>{{ 'report.house' | t }}: <strong>{{ displayValue(houseLabel) }}</strong></span>
          <span>{{ 'report.houseNo' | t }}: <strong>{{ displayValue(houseNo) }}</strong></span>
          <span>{{ 'report.address' | t }}: <strong>{{ displayValue(houseAddress) }}</strong></span>
        </div>
      </section>
    </div>

    <div class="yearly-report-loading" *ngIf="loading">
      <app-content-skeleton
        variant="table"
        [columns]="metric === 'collection' ? 6 : 4"
        [rows]="7"
      ></app-content-skeleton>
    </div>
    <div class="yearly-report-empty" *ngIf="!loading && !hasAnyData">
      {{ 'report.noDataForFlat' | t }}
    </div>

    <div class="yearly-report-section-title" *ngIf="!loading && collectionRows.length > 0">{{ 'report.collectionDetails' | t }}</div>
    <div class="yearly-report-table-wrap" *ngIf="!loading && collectionRows.length > 0">
      <div class="yearly-report-table-head collection">
        <div>{{ 'report.monthName' | t }}</div>
        <div>{{ 'report.renter' | t }}</div>
        <div>{{ 'report.paymentDate' | t }}</div>
        <div>{{ 'report.flatRent' | t }}</div>
        <div>{{ 'report.gasBill' | t }}</div>
        <div>{{ 'report.electricBill' | t }}</div>
        <div>{{ 'report.waterBill' | t }}</div>
        <div>{{ 'report.serviceChargeOther' | t }}</div>
        <div>{{ negativeChargeHeaderLabel }}</div>
        <div>{{ 'report.adjustFromAdvance' | t }}</div>
        <div>{{ 'report.totalAmount' | t }}</div>
      </div>
      <div class="yearly-report-table-body">
        <div class="yearly-report-table-row collection" *ngFor="let row of collectionRows; let i = index" [class.alt]="i % 2 === 1">
          <div>{{ row.monthLabel }}</div>
          <div>{{ row.renterName }}</div>
          <div>{{ row.paymentDateLabel }}</div>
          <div>{{ formatAmount(row.rentAmount) }}</div>
          <div>{{ formatAmount(row.gasAmount) }}</div>
          <div>{{ formatAmount(row.electricAmount) }}</div>
          <div>{{ formatAmount(row.waterAmount) }}</div>
          <div>{{ formatAmount(row.serviceAmount) }}</div>
          <div>{{ formatDeduction(row.negativeChargeAmount) }}</div>
          <div>{{ formatDeduction(row.advanceAdjustedAmount) }}</div>
          <div class="yearly-report-amount">{{ formatAmount(row.totalAmount) }}</div>
        </div>
        <div class="yearly-report-table-row yearly-report-total-row collection">
          <div>{{ 'report.finalTotal' | t }}</div>
          <div>-</div>
          <div>-</div>
          <div>{{ formatAmount(collectionTotals.rent) }}</div>
          <div>{{ formatAmount(collectionTotals.gas) }}</div>
          <div>{{ formatAmount(collectionTotals.electric) }}</div>
          <div>{{ formatAmount(collectionTotals.water) }}</div>
          <div>{{ formatAmount(collectionTotals.service) }}</div>
          <div>{{ formatDeduction(collectionTotals.negative) }}</div>
          <div>{{ formatDeduction(collectionTotals.advance) }}</div>
          <div class="yearly-report-amount">{{ formatAmount(collectionTotals.total) }}</div>
        </div>
      </div>
    </div>
    <div class="yearly-report-empty" *ngIf="!loading && collectionRows.length === 0">{{ 'report.noCollectionData' | t }}</div>

    <div class="yearly-report-section-title" *ngIf="!loading && expenseRows.length > 0">{{ 'report.expenseDetails' | t }}</div>
    <div class="yearly-report-table-wrap" *ngIf="!loading && expenseRows.length > 0">
      <div class="yearly-report-table-head expense">
        <div>{{ 'report.monthName' | t }}</div>
        <div>{{ 'report.expenseDate' | t }}</div>
        <div>{{ 'report.expenseHead' | t }}</div>
        <div>{{ 'report.amount' | t }}</div>
      </div>
      <div class="yearly-report-table-body">
        <div class="yearly-report-table-row expense" *ngFor="let row of expenseRows; let i = index" [class.alt]="i % 2 === 1">
          <div>{{ row.monthLabel }}</div>
          <div>{{ row.expenseDateLabel }}</div>
          <div>{{ row.expenseHeadName }}</div>
          <div class="yearly-report-amount">{{ formatAmount(row.expenseAmount) }}</div>
        </div>
        <div class="yearly-report-table-row yearly-report-total-row expense">
          <div>{{ 'report.finalTotal' | t }}</div>
          <div>-</div>
          <div>-</div>
          <div class="yearly-report-amount">{{ formatAmount(expenseTotalAmount) }}</div>
        </div>
      </div>
    </div>
    <div class="yearly-report-empty" *ngIf="!loading && expenseRows.length === 0">{{ 'report.noExpenseData' | t }}</div>

    <div class="yearly-report-summary" *ngIf="!loading">
      <section class="yearly-report-summary-card">
        <h5>{{ 'report.overallTotals' | t }}</h5>
        <div class="yearly-report-summary-item">
          <span class="summary-label">{{ 'report.collection' | t }}</span>
          <strong class="summary-value">{{ formatAmount(collectionTotalAmount) }}</strong>
        </div>
        <div class="yearly-report-summary-item">
          <span class="summary-label">{{ 'report.expense' | t }}</span>
          <strong class="summary-value">{{ formatAmount(expenseTotalAmount) }}</strong>
        </div>
        <div class="yearly-report-summary-item">
          <span class="summary-label">{{ 'report.netCollectionMinusExpense' | t }}</span>
          <strong class="summary-value">{{ formatAmount(netCollectionAmount) }}</strong>
        </div>
      </section>
      <section class="yearly-report-summary-card yearly-report-summary-card-rent">
        <h5>{{ 'report.rentOnlyTotals' | t }}</h5>
        <div class="yearly-report-summary-item">
          <span class="summary-label summary-label-with-info">
            <span>{{ 'report.totalFlatRent' | t }}</span>
            <button
              type="button"
              class="summary-info-btn"
              (click)="openRentOnlyInfoModal()"
              [attr.aria-label]="'report.totalFlatRentInfo' | t"
            >i</button>
          </span>
          <strong class="summary-value">{{ formatAmount(rentOnlyTotalCollectionAmount) }}</strong>
        </div>
        <div class="yearly-report-summary-item">
          <span class="summary-label">{{ 'report.netRentMinusExpense' | t }}</span>
          <strong class="summary-value">{{ formatAmount(rentOnlyNetCollectionAmount) }}</strong>
        </div>
      </section>
    </div>

    <div class="yearly-report-footer" *ngIf="!loading">
      <span>{{ 'report.generatedOn' | t }}: <strong>{{ displayValue(generatedOn) }}</strong></span>
      <span>{{ 'report.generatedBy' | t }}: <strong>{{ displayValue(generatedBy) }}</strong></span>
    </div>

    <div class="summary-info-modal-overlay" *ngIf="showRentOnlyInfoModal" (click)="closeRentOnlyInfoModal()">
      <div class="summary-info-modal" (click)="$event.stopPropagation()">
        <button type="button" class="summary-info-close" (click)="closeRentOnlyInfoModal()" [attr.aria-label]="'common.close' | t">&times;</button>
        <h5>{{ 'report.totalFlatRentCalculation' | t }}</h5>
        <p>{{ 'report.totalFlatRentFormula' | t }} {{ negativeChargeHeaderLabel }} - {{ 'report.adjustFromAdvance' | t }}</p>
        <div class="summary-info-equation">
          {{ formatAmount(collectionTotals.rent) }}
          -
          {{ formatAmount(totalNegativeChargeAmount) }}
          -
          {{ formatAmount(totalAdvanceAdjustedAmount) }}
          =
          <strong>{{ formatAmount(rentOnlyTotalCollectionAmount) }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>
